(function () {
	'use strict';

	var selectedIndex = 0;
	var swiperInstance = null;

	function initSwiper() {
		if (swiperInstance) {
			swiperInstance.destroy(true, true);
			swiperInstance = null;
		}

		swiperInstance = new Swiper('#plans-swiper', {
			slidesPerView: 'auto',
			centeredSlides: true,
			spaceBetween: 12,
			loop: true,
			loopAdditionalSlides: 2,
			loopedSlides: 4,
			initialSlide: selectedIndex,
			pagination: '#swiper-pagination',
			paginationClickable: true,
			nextButton: '.swiper-button-next',
			prevButton: '.swiper-button-prev',
			breakpoints: {
				576: {
					spaceBetween: 10
				}
			},
			onSlideChangeEnd: function (swiper) {
				var activeSlide = swiper.slides[swiper.activeIndex];
				var packId = activeSlide.getAttribute('data-pack-id');
				var valid_pack = null;

				for (var i = 0; i < packs.length; i++) {
					if (String(packs[i].id) === packId) {
						valid_pack = packs[i];
						break;
					}
				};
				if (valid_pack) {
					document.getElementById('plans-broadband-facts').classList.remove('d-none');
					try {
						updateBroadbandCardDetails(valid_pack, 'plan_broadband_facts', autumn_2026_offer, promo_oct2026);
					} catch (e) {
						console.error(`Error calling updateBroadbandCardDetails: ${e.message}`);
					}
				} else {
					document.getElementById('plans-broadband-facts').classList.add('d-none');
				}
			}
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		initSwiper();
	});

})();
